import { render } from "./custom-btn.vue?vue&type=template&id=2aefb388&scoped=true&ts=true"
import script from "./custom-btn.vue?vue&type=script&lang=ts"
export * from "./custom-btn.vue?vue&type=script&lang=ts"

import "./custom-btn.vue?vue&type=style&index=0&id=2aefb388&lang=scss&scoped=true"

import exportComponent from "/Users/panren/Desktop/太平洋网络/discount-topics-wap-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aefb388"]])

export default __exports__